(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spg-catalog-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCatalogUi = () => {
    document.querySelectorAll('[data-spg-catalog]').forEach((shell) => {
      if (shell.dataset.spgUiReady === 'true') return;
      shell.dataset.spgUiReady = 'true';

      shell.querySelectorAll('[data-spg-story-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const details = button.closest('.spg-collection-story');
          if (!details) return;

          const summary = details.querySelector('summary');
          details.open = false;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          details.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'center'
          });

          if (summary) {
            window.setTimeout(() => summary.focus({ preventScroll: true }), reduceMotion ? 0 : 350);
          }
        });
      });
    });
  };

  const initInfiniteCatalog = () => {
    document.querySelectorAll('[data-spg-catalog]').forEach((shell) => {
      if (shell.dataset.spgInfiniteReady === 'true') return;

      const grid = shell.querySelector('.spg-catalog-grid');
      const sentinel = shell.querySelector('[data-spg-infinite]');
      if (!grid || !sentinel || !sentinel.dataset.nextUrl) return;

      shell.dataset.spgInfiniteReady = 'true';

      let loading = false;
      const status = sentinel.querySelector('.spg-catalog-infinite__status');

      const observer = new IntersectionObserver(
        async (entries) => {
          if (!entries[0]?.isIntersecting || loading) return;

          const nextUrl = sentinel.dataset.nextUrl;
          if (!nextUrl) {
            observer.disconnect();
            return;
          }

          loading = true;
          sentinel.classList.add('is-loading');
          if (status) status.textContent = 'טוענים עוד מוצרים…';

          try {
            const url = new URL(nextUrl, window.location.origin);
            const response = await fetch(url.toString(), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });

            if (!response.ok) throw new Error('Failed to load next collection page');

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const nextShell = html.querySelector('[data-spg-catalog]');
            const nextGrid = nextShell?.querySelector('.spg-catalog-grid');
            const nextSentinel = nextShell?.querySelector('[data-spg-infinite]');
            const cards = nextGrid
              ? Array.from(nextGrid.children).filter((node) => node.classList.contains('spg-catalog-card'))
              : [];

            if (!cards.length) {
              sentinel.removeAttribute('data-next-url');
              sentinel.classList.add('is-done');
              if (status) status.textContent = '';
              observer.disconnect();
              return;
            }

            const fragment = document.createDocumentFragment();
            cards.forEach((card) => fragment.appendChild(card));
            grid.appendChild(fragment);

            const followingUrl = nextSentinel?.dataset.nextUrl || '';
            if (followingUrl) {
              sentinel.dataset.nextUrl = followingUrl;
              if (status) status.textContent = '';
            } else {
              sentinel.removeAttribute('data-next-url');
              sentinel.classList.add('is-done');
              if (status) status.textContent = '';
              observer.disconnect();
            }
          } catch (error) {
            if (status) status.textContent = 'לא הצלחנו לטעון עוד מוצרים. גללו מעט ונסו שוב.';
          } finally {
            loading = false;
            sentinel.classList.remove('is-loading');
          }
        },
        { rootMargin: '700px 0px' }
      );

      observer.observe(sentinel);
    });
  };

  const initCatalog = () => {
    initCatalogUi();
    initInfiniteCatalog();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCatalog, { once: true });
  } else {
    initCatalog();
  }

  document.addEventListener('shopify:section:load', initCatalog);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spg-catalog-page"] && !Shopify.designMode) return;
  try {
    
function initSpgInfiniteCatalog(){
  document.querySelectorAll('[data-spg-catalog]').forEach(function(section){
    if(section.dataset.spgInfiniteReady==='true') return;
    var grid=section.querySelector('.spg-catalog-grid');
    var control=section.querySelector('[data-spg-infinite]');
    if(!grid||!control) return;
    section.dataset.spgInfiniteReady='true';
    var loading=false;
    var observer=new IntersectionObserver(async function(entries){
      if(!entries.some(function(entry){return entry.isIntersecting;})||loading) return;
      var link=control.querySelector('.spg-catalog-infinite-next');
      var href=link&&link.getAttribute('href');
      if(!href){observer.disconnect();return;}
      loading=true;
      control.classList.remove('is-error');
      control.classList.add('is-loading');
      try{
        var url=new URL(href,window.location.origin);
        var response=await fetch(url.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok) throw new Error('catalog');
        var html=await response.text();
        var doc=new DOMParser().parseFromString(html,'text/html');
        var incoming=doc.querySelector('[data-spg-catalog]');
        var incomingGrid=incoming&&incoming.querySelector('.spg-catalog-grid');
        var cards=incomingGrid?Array.from(incomingGrid.querySelectorAll(':scope > .spg-catalog-card')):[];
        cards.forEach(function(card){grid.appendChild(card);});
        var incomingControl=incoming&&incoming.querySelector('[data-spg-infinite]');
        var next=incomingControl&&incomingControl.querySelector('.spg-catalog-infinite-next');
        var nextHref=next&&next.getAttribute('href');
        if(nextHref&&cards.length){
          link.setAttribute('href',nextHref);
        }else{
          observer.disconnect();
          control.remove();
        }
      }catch(error){
        control.classList.add('is-error');
        observer.disconnect();
      }finally{
        loading=false;
        control.classList.remove('is-loading');
      }
    },{rootMargin:'700px 0px'});
    observer.observe(control);
  });
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',initSpgInfiniteCatalog,{once:true});
}else{
  initSpgInfiniteCatalog();
}
document.addEventListener('shopify:section:load',initSpgInfiniteCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spg-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initFooterBackToTop = () => {
    document.querySelectorAll('[data-spg-footer-back-to-top]').forEach((button) => {
      if (button.dataset.spgReady === 'true') return;
      button.dataset.spgReady = 'true';

      button.addEventListener('click', () => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterBackToTop, { once: true });
  } else {
    initFooterBackToTop();
  }

  document.addEventListener('shopify:section:load', initFooterBackToTop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spg-shopping-tools"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spg-vat-calculator')) {
    customElements.define('spg-vat-calculator', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const form = this.querySelector('form');
        const amount = form.elements.amount;
        const mode = form.elements.mode;
        const result = this.querySelector('.spg-vat-result');
        const money = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS' });
        const round = value => Math.round((value + Number.EPSILON) * 100) / 100;
        const calculate = () => {
          const value = amount.valueAsNumber;
          const rate = Number(this.dataset.rate) / 100;
          if (!amount.validity.valid || !Number.isFinite(value) || value < 0 || !Number.isFinite(rate) || rate < 0) {
            result.hidden = true;
            return;
          }
          const net = mode.value === 'remove' ? round(value / (1 + rate)) : round(value);
          const gross = mode.value === 'remove' ? round(value) : round(net * (1 + rate));
          const tax = round(gross - net);
          this.querySelector('[data-vat-net]').textContent = money.format(net);
          this.querySelector('[data-vat-tax]').textContent = money.format(tax);
          this.querySelector('[data-vat-gross]').textContent = money.format(gross);
          result.hidden = false;
        };
        form.addEventListener('submit', event => { event.preventDefault(); calculate(); }, { signal: this.controller.signal });
        form.addEventListener('input', () => { if (!result.hidden) calculate(); }, { signal: this.controller.signal });
        form.addEventListener('change', () => { if (!result.hidden) calculate(); }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spg-size-tools"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spg-size-tools')) {
  class SpgSizeTools extends HTMLElement {
    connectedCallback() {
      this.clothesTable={
        women:[{size:'S',chest:88,waist:70,hips:94},{size:'M',chest:94,waist:76,hips:100},{size:'L',chest:100,waist:82,hips:106},{size:'XL',chest:106,waist:88,hips:112},{size:'XXL',chest:114,waist:96,hips:120},{size:'XXXL',chest:122,waist:104,hips:128}],
        men:[{size:'S',chest:94,waist:80,hips:96},{size:'M',chest:101,waist:87,hips:103},{size:'L',chest:108,waist:94,hips:110},{size:'XL',chest:116,waist:102,hips:118},{size:'XXL',chest:124,waist:110,hips:126},{size:'XXXL',chest:132,waist:118,hips:134}]
      };
      this.ringTable=[{us:'3',d:14.1,c:44.2},{us:'3.5',d:14.5,c:45.5},{us:'4',d:14.9,c:46.8},{us:'4.5',d:15.3,c:48},{us:'5',d:15.7,c:49.3},{us:'5.5',d:16.1,c:50.6},{us:'6',d:16.5,c:51.9},{us:'6.5',d:16.9,c:53.1},{us:'7',d:17.3,c:54.4},{us:'7.5',d:17.7,c:55.7},{us:'8',d:18.1,c:57},{us:'8.5',d:18.5,c:58.3},{us:'9',d:18.9,c:59.5},{us:'9.5',d:19.4,c:60.8},{us:'10',d:19.8,c:62.1},{us:'10.5',d:20.2,c:63.4},{us:'11',d:20.6,c:64.6},{us:'11.5',d:21,c:65.9},{us:'12',d:21.4,c:67.2},{us:'12.5',d:21.8,c:68.5},{us:'13',d:22.2,c:69.7},{us:'13.5',d:22.6,c:71},{us:'14',d:23,c:72.3},{us:'14.5',d:23.4,c:73.5},{us:'15',d:23.8,c:74.8}];
      this.bindShoes();this.bindClothes();this.bindRings();
    }
    bindShoes(){
      const form=this.querySelector('[data-shoe-form]');if(!form)return;
      form.addEventListener('submit',(e)=>{
        e.preventDefault();
        const length=Number(new FormData(form).get('shoe_length'));
        let eu=Math.round((length+1.5)*1.5);
        eu=Math.max(22,Math.min(50,eu));
        const reference=(eu/1.5)-1.5;
        this.querySelector('[data-shoe-size]').textContent='EU '+eu;
        this.querySelector('[data-shoe-copy]').textContent='לכף רגל באורך '+this.num(length)+' ס״מ. אורך הייחוס למידה זו הוא בערך '+this.num(reference)+' ס״מ.';
        this.querySelector('[data-shoe-result]').hidden=false;
      });
    }
    bindClothes(){
      const form=this.querySelector('[data-clothes-form]');if(!form)return;
      form.addEventListener('submit',(e)=>{
        e.preventDefault();
        const data=new FormData(form);
        const table=this.clothesTable[data.get('clothes_type')]||this.clothesTable.women;
        const measurements={chest:Number(data.get('chest')),waist:Number(data.get('waist')),hips:Number(data.get('hips'))};
        const provided=Object.entries(measurements).filter(([,value])=>Number.isFinite(value)&&value>0);
        if(!provided.length){
          this.querySelector('[data-clothes-size]').textContent='חסרה מדידה';
          this.querySelector('[data-clothes-copy]').textContent='הזינו לפחות חזה, מותניים או ירכיים.';
          this.querySelector('[data-clothes-result]').hidden=false;
          return;
        }
        const indexes=provided.map(([key,value])=>{const i=table.findIndex((row)=>value<=row[key]);return i===-1?table.length:i;});
        const i=Math.max(...indexes);
        if(i>=table.length){
          this.querySelector('[data-clothes-size]').textContent='מעל XXXL';
          this.querySelector('[data-clothes-copy]').textContent='המדידה חורגת מטווח S–XXXL שבמחשבון. חפשו טבלת מידות מורחבת אצל הספק.';
        }else{
          this.querySelector('[data-clothes-size]').textContent=table[i].size;
          this.querySelector('[data-clothes-copy]').textContent='המידה חושבה לפי המדידה הגדולה ביותר שהוזנה, כדי לצמצם סיכוי לבגד קטן מדי.';
        }
        this.querySelector('[data-clothes-result]').hidden=false;
      });
    }
    bindRings(){
      const form=this.querySelector('[data-ring-form]');if(!form)return;
      const mode=form.querySelector('[data-ring-mode]');
      const input=form.querySelector('[data-ring-value]');
      const sync=()=>{
        if(mode.value==='circumference'){input.min='44';input.max='75';input.placeholder='למשל 54.4';}
        else{input.min='14';input.max='24';input.placeholder='למשל 17.3';}
      };
      mode.addEventListener('change',sync);sync();
      form.addEventListener('submit',(e)=>{
        e.preventDefault();
        const data=new FormData(form);
        const value=Number(data.get('ring_value'));
        const c=data.get('ring_mode')==='diameter'?value*Math.PI:value;
        let row=this.ringTable[0];
        for(const x of this.ringTable){if(Math.abs(x.c-c)<Math.abs(row.c-c))row=x;}
        this.querySelector('[data-ring-size]').textContent='US '+row.us+' · EU '+Math.round(row.c);
        this.querySelector('[data-ring-copy]').textContent='קוטר פנימי משוער '+row.d.toFixed(1)+' מ״מ · היקף '+row.c.toFixed(1)+' מ״מ.';
        this.querySelector('[data-ring-result]').hidden=false;
      });
    }
    num(v){return Number(v).toFixed(1).replace('.0','');}
  }
  customElements.define('spg-size-tools',SpgSizeTools);
}

  } catch(e) { console.error(e); }
})();
})();
